(function ($) {
    var defaults= {
        'loadingText' : 'Loading'
    };
    $.fn.extend({
        loader: function(options) {
            options = $.extend({}, defaults, options||{});

            return this.each(function() {
                $(this).html('<div class="loader-box"> \
                    <div class="label">' + options.loadingText + '</div> \
                    <div class="loader"> \
                    <div class="element-animation"> \
                    </div> \
                    <div class="road"></div> \
                    </div> \
                    </div> \
                ');
            });
        }
    });
})(jQuery);
